import { useTranslation } from 'react-i18next';
import { Page } from '@web/components/page';
import { TestimonialsScreen, TestimonialsScreenProps } from 'shared/screens/testimonials';
import { withServerProps } from '@web/library/with-server-props';

export default function Testimonials(props: TestimonialsScreenProps) {
  const { t } = useTranslation('screens');

  return (
    <Page
      {...props}
      register={(seo) =>
        seo.setTitle(t('testimonials.title')).setDescription(t('testimonials.description'))
      }
    >
      <TestimonialsScreen {...props} />
    </Page>
  );
}

export const getServerSideProps = withServerProps();
